import { Link, Outlet } from "react-router";
import { SharedRunScope } from "@/features/shared/SharedRunScope";
import { BUILD_ENV } from "@/lib/buildInfo";
import { Badge } from "@/components/ui/badge";
import { ThemeMenu } from "../shell/ThemeMenu";
import { UserMenu } from "../shell/UserMenu";

export function SharedLayout() {
  return (
    <div className="flex min-h-dvh flex-col bg-background">
      <header
        role="banner"
        className="sticky top-0 z-30 flex h-14 items-center gap-2 border-b bg-background/95 px-3 backdrop-blur no-print"
      >
        <Link to="/" aria-label="ATATUS Test Suite home" className="flex items-center gap-2 font-semibold">
          <img src="/ats.svg" alt="" className="size-6" />
          <span className="hidden sm:inline">ATATUS Test Suite</span>
        </Link>
        {BUILD_ENV !== "production" && (
          <Badge variant="outline" className="font-mono">
            {BUILD_ENV === "staging" ? "STAGING" : "DEV"}
          </Badge>
        )}
        <div className="flex-1" />
        <ThemeMenu />
        <UserMenu />
      </header>
      <main id="main" tabIndex={-1} className="mx-auto w-full max-w-[1440px] flex-1 px-3 py-4 sm:px-4 md:px-6">
        <SharedRunScope>
          <Outlet />
        </SharedRunScope>
      </main>
    </div>
  );
}

export function SharedReportLayout() {
  return (
    <main id="main" tabIndex={-1} className="mx-auto w-full max-w-[880px] bg-background px-4 py-8 print:max-w-none print:px-0">
      <SharedRunScope>
        <Outlet />
      </SharedRunScope>
    </main>
  );
}
